import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Stratix Group (STX)</title>
        <meta property="og:title" content="Stratix Group (STX)" />
        <link
          rel="canonical"
          href="https://swift-luminous-porcupine-7pvu8b.teleporthq.app/"
        />
      </Helmet>
      <Navigation></Navigation>
      <main className="stratix-homepage">
        <section className="hero-section">
          <div className="hero-background">
            <img
              alt="Stratix Group Construction Site"
              src="https://images.pexels.com/photos/93400/pexels-photo-93400.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="hero-bg-image"
            />
            <div className="hero-overlay"></div>
          </div>
          <div className="hero-container">
            <div className="hero-content">
              <div className="hero-badge-row">
                <span className="stx-shorthand">
                  Skilled • Trusted • Execution
                </span>
              </div>
              <h1 className="home-hero-title hero-title">
                Disciplined Construction Management &amp; Specialized Trades
              </h1>
              <p className="home-hero-subtitle hero-subtitle">
                Stratix Group is a vertically integrated holding organization
                overseeing a portfolio of licensed operating companies
                delivering excellence in general construction, restoration, and
                specialty trades.
              </p>
              <div className="hero-cta-group">
                <a href="#divisions">
                  <div className="btn-lg btn btn-primary">
                    <span>Divisions &amp; Services</span>
                  </div>
                </a>
                <a href="#about">
                  <div className="btn-outline btn-lg btn">
                    <span>About Stratix Group</span>
                  </div>
                </a>
              </div>
              <div className="hero-trust-badges">
                <div className="trust-item">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  </svg>
                  <span>Licensed &amp; Bonded</span>
                </div>
                <div className="trust-item">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 11 12 14 22 4"></polyline>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                  <span>OSHA Compliant</span>
                </div>
                <div className="trust-item">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" x2="8" y1="13" y2="13"></line>
                    <line x1="16" x2="8" y1="17" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                  <span>ISO Certified</span>
                </div>
              </div>
            </div>
            <div className="hero-visual">
              <div className="hero-image-frame">
                <img
                  alt="Institutional Architecture"
                  src="https://images.pexels.com/photos/14903989/pexels-photo-14903989.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
            </div>
          </div>
        </section>
        <section id="about" className="about-section">
          <div className="section-container">
            <div className="about-bento">
              <div className="about-bento-side">
                <h2 className="section-title">Operating Structure</h2>
                <p className="section-content">
                  Stratix Group functions as the central governance body for a
                  network of specialized construction entities. Our vertical
                  integration ensures seamless coordination between general
                  management and specialized trade execution.
                </p>
                <div className="stx-reinforcement">
                  <span className="stx-letter">S</span>
                  <span className="stx-letter">T</span>
                  <span className="stx-letter">X</span>
                </div>
              </div>
              <div className="about-bento-main">
                <div className="structure-grid">
                  <div className="structure-card">
                    <div className="card-header">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          x="3"
                          y="3"
                          rx="2"
                          ry="2"
                          width="18"
                          height="18"
                        ></rect>
                        <line x1="3" x2="21" y1="9" y2="9"></line>
                        <line x1="9" x2="9" y1="21" y2="9"></line>
                      </svg>
                      <h3>Stratix Holding</h3>
                    </div>
                    <p>
                      Corporate governance, compliance oversight, and strategic
                      procurement for all divisions.
                    </p>
                  </div>
                  <div className="structure-card">
                    <div className="card-header">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                      <h3>General Construction</h3>
                    </div>
                    <p>
                      Full-spectrum project management for residential,
                      commercial, and municipal sectors.
                    </p>
                  </div>
                  <div className="structure-card">
                    <div className="card-header">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                      </svg>
                      <h3>Trade Divisions</h3>
                    </div>
                    <p>
                      In-house specialized trades including MEP, restoration,
                      and structural engineering.
                    </p>
                  </div>
                  <div className="highlight structure-card">
                    <div className="card-header">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle r="10" cx="12" cy="12"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      <h3>Integrated Delivery</h3>
                    </div>
                    <p>
                      A unified approach reducing lead times and ensuring strict
                      regulatory adherence across all sites.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="divisions" className="features-section">
          <div className="section-container">
            <div className="features-header">
              <h2 className="section-title">Primary Capabilities</h2>
              <p className="section-subtitle">
                Specialized solutions for high-stakes environments.
              </p>
            </div>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <svg
                    fill="none"
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                </div>
                <h3>General Construction</h3>
                <p className="section-content">
                  Comprehensive site management and execution for new builds and
                  major renovations in residential and commercial sectors.
                </p>
                <ul className="feature-list">
                  <li>
                    <span>Municipal Infrastructure</span>
                  </li>
                  <li>
                    <span>Commercial Developments</span>
                  </li>
                  <li>
                    <span>High-End Residential</span>
                  </li>
                </ul>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <svg
                    fill="none"
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  </svg>
                </div>
                <h3>Restoration &amp; Recovery</h3>
                <p className="section-content">
                  Rapid response and technical restoration services for
                  insurance carriers and property managers post-loss.
                </p>
                <ul className="feature-list">
                  <li>
                    <span>Disaster Mitigation</span>
                  </li>
                  <li>
                    <span>Structural Reinforcement</span>
                  </li>
                  <li>
                    <span>Insurance Coordination</span>
                  </li>
                </ul>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <svg
                    fill="none"
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                  </svg>
                </div>
                <h3>MEP Services</h3>
                <p className="section-content">
                  Mechanical, Electrical, and Plumbing engineering and
                  installation for complex industrial and municipal facilities.
                </p>
                <ul className="feature-list">
                  <li>
                    <span>HVAC Systems</span>
                  </li>
                  <li>
                    <span>Electrical Grid Integration</span>
                  </li>
                  <li>
                    <span>Industrial Plumbing</span>
                  </li>
                </ul>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <svg
                    fill="none"
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                </div>
                <h3>Specialty Trades</h3>
                <p className="section-content">
                  Niche trade execution including masonry, advanced concrete
                  work, and architectural metal fabrication.
                </p>
                <ul className="feature-list">
                  <li>
                    <span>Precision Concrete</span>
                  </li>
                  <li>
                    <span>Steel Fabrication</span>
                  </li>
                  <li>
                    <span>Envelope Systems</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="case-studies-section">
          <div className="case-studies-header">
            <h2 className="section-title">Portfolio of Execution</h2>
            <p className="section-subtitle">
              Delivering scale and compliance across diverse markets.
            </p>
          </div>
          <div className="case-grid">
            <div className="case-card">
              <img
                alt="Municipal Project"
                src="https://images.pexels.com/photos/17297268/pexels-photo-17297268.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="case-img"
              />
              <div className="case-overlay">
                <div className="case-content">
                  <span className="case-tag">Municipal</span>
                  <h3>District Infrastructure Hub</h3>
                  <p>
                    Phase II utility integration and structural reinforcement
                    for regional transit center.
                  </p>
                  <a href="#">
                    <div className="btn btn-link">
                      <span>View Case Study</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="case-card">
              <img
                alt="Commercial Project"
                src="https://images.pexels.com/photos/5612890/pexels-photo-5612890.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="case-img"
              />
              <div className="case-overlay">
                <div className="case-content">
                  <span className="case-tag">Commercial</span>
                  <h3>Skyline Corporate Plaza</h3>
                  <p>
                    Full-spectrum general construction for 450,000 sq. ft. LEED
                    Gold facility.
                  </p>
                  <a href="#">
                    <div className="btn btn-link">
                      <span>View Case Study</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="case-card">
              <img
                alt="Restoration Project"
                src="https://images.pexels.com/photos/30415240/pexels-photo-30415240.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="case-img"
              />
              <div className="case-overlay">
                <div className="case-content">
                  <span className="case-tag">Restoration</span>
                  <h3>Harbor View Restoration</h3>
                  <p>
                    Complex structural recovery and MEP overhaul following
                    critical facility loss.
                  </p>
                  <a href="#">
                    <div className="btn btn-link">
                      <span>View Case Study</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="case-card">
              <img
                alt="Industrial Project"
                src="https://images.pexels.com/photos/7108785/pexels-photo-7108785.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="case-img"
              />
              <div className="case-overlay">
                <div className="case-content">
                  <span className="case-tag">Industrial</span>
                  <h3>Logistics Core Alpha</h3>
                  <p>
                    Specialized trade execution for heavy-load concrete flooring
                    and steel framing.
                  </p>
                  <a href="#">
                    <div className="btn btn-link">
                      <span>View Case Study</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="case-card">
              <img
                alt="Government Project"
                src="https://images.pexels.com/photos/18830357/pexels-photo-18830357.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="case-img"
              />
              <div className="case-overlay">
                <div className="case-content">
                  <span className="case-tag">Government</span>
                  <h3>Federal Annex Upgrade</h3>
                  <p>
                    Secure-site MEP modernization and structural envelope
                    reinforcement.
                  </p>
                  <a href="#">
                    <div className="btn btn-link">
                      <span>View Case Study</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="case-card">
              <img
                alt="Residential Project"
                src="https://images.pexels.com/photos/13246505/pexels-photo-13246505.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="case-img"
              />
              <div className="case-overlay">
                <div className="case-content">
                  <span className="case-tag">Residential</span>
                  <h3>The Heights Estates</h3>
                  <p>
                    Multi-unit luxury residential development with integrated
                    trade management.
                  </p>
                  <a href="#">
                    <div className="btn btn-link">
                      <span>View Case Study</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="process-section">
          <div className="section-container">
            <div className="process-intro">
              <h2 className="section-title">Governed Execution Process</h2>
              <p className="section-subtitle">
                Our standardized approach ensures safety, compliance, and
                predictable delivery.
              </p>
            </div>
            <div className="process-steps">
              <div className="step-item">
                <div className="step-number">
                  <span>01</span>
                </div>
                <div className="step-line"></div>
                <h4>Procurement</h4>
                <p>
                  Rigorous vetting of materials and specialized labor resources.
                </p>
              </div>
              <div className="step-item">
                <div className="step-number">
                  <span>02</span>
                </div>
                <div className="step-line"></div>
                <h4>Permitting</h4>
                <p>
                  Comprehensive regulatory alignment and municipal coordination.
                </p>
              </div>
              <div className="step-item">
                <div className="step-number">
                  <span>03</span>
                </div>
                <div className="step-line"></div>
                <h4>Mobilization</h4>
                <p>
                  Disciplined site setup with focus on OSHA safety standards.
                </p>
              </div>
              <div className="step-item">
                <div className="step-number">
                  <span>04</span>
                </div>
                <div className="step-line"></div>
                <h4>Execution</h4>
                <p>
                  Vertically integrated trade coordination and daily QA
                  reporting.
                </p>
              </div>
              <div className="step-item">
                <div className="step-number">
                  <span>05</span>
                </div>
                <div className="step-line"></div>
                <h4>Delivery</h4>
                <p>
                  Final commissioning, compliance certification, and handover.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="testimonials-section">
          <div className="testimonials-container">
            <div className="testimonials-header">
              <h2 className="section-title">Institutional Trust</h2>
            </div>
            <div className="testimonials-rail">
              <div className="testimonial-card">
                <p className="quote">
                  &quot;Stratix Group&apos;s vertical integration was the
                  deciding factor for our infrastructure project. Their ability
                  to manage specialized trades in-house reduced our timeline by
                  15%.&quot;
                </p>
                <div className="client-info">
                  <strong>Marcus Thorne</strong>
                  <span>Director of Municipal Facilities</span>
                </div>
              </div>
              <div className="testimonial-card">
                <p className="quote">
                  &quot;As an insurance adjuster, I value the discipline Stratix
                  brings to restoration. Their documentation and compliance
                  standards are the gold standard in the industry.&quot;
                </p>
                <div className="client-info">
                  <strong>Sarah Jenkins</strong>
                  <span>Senior Claims Manager, Global Insure</span>
                </div>
              </div>
              <div className="testimonial-card">
                <p className="quote">
                  &quot;A highly disciplined organization. They handled our
                  commercial skyscraper restoration with surgical precision
                  under extremely tight regulatory oversight.&quot;
                </p>
                <div className="client-info">
                  <strong>Robert Chen</strong>
                  <span>VP of Operations, Skyline Realty Group</span>
                </div>
              </div>
              <div className="testimonial-card">
                <p className="quote">
                  &quot;The STX shorthand—Skilled, Trusted, Execution—is not
                  just a slogan. It is evident in every safety meeting and
                  project milestone they deliver.&quot;
                </p>
                <div className="client-info">
                  <strong>Col. David Vance</strong>
                  <span>Government Procurement Liaison</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="cta-section">
          <div className="section-container">
            <div className="cta-grid">
              <div className="cta-content-block">
                <h2 className="section-title">Connect with Stratix</h2>
                <p className="section-content">
                  Direct access to our specialized divisions and corporate
                  governance team for project inquiries and partnership
                  opportunities.
                </p>
              </div>
              <div className="cta-action-card">
                <h3>Commercial &amp; Municipal</h3>
                <p>For large-scale developments and government procurement.</p>
                <a href="#">
                  <div className="btn btn-primary">
                    <span>Division Access</span>
                  </div>
                </a>
              </div>
              <div className="cta-action-card">
                <h3>Insurers &amp; Adjusters</h3>
                <p>Priority restoration and technical recovery assessment.</p>
                <a href="#">
                  <div className="btn btn-secondary">
                    <span>Loss Recovery</span>
                  </div>
                </a>
              </div>
              <div className="cta-action-card">
                <h3>Corporate Governance</h3>
                <p>Inquiries regarding the Stratix operating structure.</p>
                <a href="#">
                  <div className="btn-outline btn">
                    <span>Contact HQ</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script defer data-name="stratix-homepage-logic">
(function(){
  const testimonialsRail = document.querySelector('.testimonials-rail');
  
  if (testimonialsRail) {
    let isDown = false;
    let startX;
    let scrollLeft;

    testimonialsRail.addEventListener('mousedown', (e) => {
      isDown = true;
      testimonialsRail.classList.add('active');
      startX = e.pageX - testimonialsRail.offsetLeft;
      scrollLeft = testimonialsRail.scrollLeft;
    });

    testimonialsRail.addEventListener('mouseleave', () => {
      isDown = false;
      testimonialsRail.classList.remove('active');
    });

    testimonialsRail.addEventListener('mouseup', () => {
      isDown = false;
      testimonialsRail.classList.remove('active');
    });

    testimonialsRail.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - testimonialsRail.offsetLeft;
      const walk = (x - startX) * 2;
      testimonialsRail.scrollLeft = scrollLeft - walk;
    });
  }

  const revealOnScroll = () => {
    const elements = document.querySelectorAll('.structure-card, .feature-item, .case-card, .step-item');
    const windowHeight = window.innerHeight;

    elements.forEach(el => {
      const elementTop = el.getBoundingClientRect().top;
      if (elementTop < windowHeight - 50) {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }
    });
  };

  document.querySelectorAll('.structure-card, .feature-item, .case-card, .step-item').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'all 0.6s ease-out';
  });

  window.addEventListener('scroll', revealOnScroll);
  revealOnScroll();
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
